import dayjs from 'dayjs';

const isWithinLastMinute = (date) => {
  const oneMinuteAgo = dayjs().subtract(1, 'minute');
  return dayjs(date).isAfter(oneMinuteAgo);
};

export default isWithinLastMinute;
